<template>
  <!-- v-if="this.byqtnum.length>0" -->
  <div id="threeOrone" v-if="this.byqtnum.length > 0">
    <el-dropdown trigger="click" @command="handleCommand">
      <span class="el-dropdown-link">
        {{ name ? name : loopName
        }}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <div id="displayBock">
        <el-dropdown-menu class="add" slot="dropdown" split-button="true">
          <el-dropdown-item
            v-for="(item, index) in byq"
            :key="index"
            :command="index"
          >
            <div class="el-item">{{ item.device_name }}</div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </div>
    </el-dropdown>
  </div>
  <div v-else>变压器温度</div>
</template>
<script>
import { chainIndex } from "../../../api/linkindex";
export default {
  name: "threeOrone",
  data() {
    return {
      byqtnum: [],
      name: "",
      loopName: "",
      num: "",
      id: 0,
    };
  },
  mounted() {
    this.areaId();
  },
  computed: {
    byq() {
      return this.byqtnum.map((item) => {
        let c = item.device_name;
        item.device_name = c;

        return item;
      });
    },
  },
  methods: {
    areaId() {
      this.id = this.$store.state.homeitem.areaId;
      chainIndex.transformerId(this.id).then((res) => {
        // console.log(res.data.data.list);
        this.byqtnum = res.data.data.list;

        // console.log(this.byqtnum);
        this.loopName = this.byqtnum[0].device_name;
        // console.log(this.loopName);
        this.$emit("transformer", this.byqtnum[0].subLoopUrl);
      });
    },
    handleCommand(command) {
      return this.byqtnum.map((item, index) => {
        if (command == index) {
          // item.loopName=item.loopName.slice(0,5)
          let c = item.device_name;
          item.device_name = c;
        //   console.log(item.device_name);
          this.name = item.device_name;
          this.num = item.subLoopUrl;
          this.$emit("tNum", this.num);
          return item;
        }
      });
      // });
    },
  },
};
</script>
<style lang="less" scoped>
#threeOrone {
  // width: 200rem !important;
  // text-align: center;
  // line-height: center;
  cursor: pointer;
}
.el-dropdown-link {
  font-size: 20rem;
}
</style>
